import { DEAL_METRICS } from "@loanbossinc/component-library";

export const getDealMetric = (deal, metricId) => {
  if (deal?.dealMetrics) {
    return deal.dealMetrics.find(metric => metric.metricId === metricId) || {};
  }

  return {};
};

export const getValueMetric = (deal, useNewMetrics = true) => {
  if (!deal) {
    return null;
  }

  const marketValueMetricId = useNewMetrics ? DEAL_METRICS.MARKET_VALUE_NEW : DEAL_METRICS.MARKET_VALUE;
  const marketValueMetric = getDealMetric(deal, marketValueMetricId);

  if (!marketValueMetric?.decimalValue) {
    const appraisedValueMetricId = useNewMetrics ? DEAL_METRICS.APPRAISED_VALUE_NEW : DEAL_METRICS.APPRAISED_VALUE;
    const appraisedValueMetric = getDealMetric(deal, appraisedValueMetricId);

    if (appraisedValueMetric?.decimalValue > 0) {
      return {
        data: appraisedValueMetric,
        id: appraisedValueMetricId,
        label: "Appraised Value"
      };
    }
  }

  return {
    data: marketValueMetric,
    id: marketValueMetricId,
    label: "Market Value"
  };
};
